// Size Guide Page - Toggle between inches and cm table
(function() {
   document.addEventListener('DOMContentLoaded', function() {
      const inchesTable = document.getElementById('size-inches');
      const cmTable = document.getElementById('size-cm');
      const btnInches = document.getElementById('btn-inches');
      const btnCm = document.getElementById('btn-cm');

      if (!inchesTable || !cmTable || !btnInches || !btnCm) return;

      cmTable.style.display = 'none';

      btnInches.addEventListener('click', function() {
        btnInches.classList.add('active');
        btnCm.classList.remove('active');
        inchesTable.style.display = 'block';
        cmTable.style.display = 'none';
      });

      btnCm.addEventListener('click', function() {
        btnCm.classList.add('active');
        btnInches.classList.remove('active');
        cmTable.style.display = 'block';
        inchesTable.style.display = 'none';
      });
    });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();